module.exports = __webpack_public_path__ + "static/media/instagram-1675670_640.e9d678f1.png";